import { MyHeartHealthContent } from "./myHeartHealth";

export const MyHeartHealth = MyHeartHealthContent;
